import { useEffect } from 'react';
import styled from 'styled-components';
import { useTitleAndUser } from '../../../hooks/userTitle';
import { useNewTheme } from '../../../hooks/useNewTheme';
import { Content, TutoriaisContainer, PageIntro, TutorialPlayer, LibraryHeading } from '../Tutoriais/tutorialLayout';
import image1 from '../../../assets/background/Banner_Cursosv2.png';
import { CarouselTutoriais } from '../Tutoriais/components/CarouselTutoriais';

const CourseBanner = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 16px;
  margin-bottom: 28px;
  border: 1px solid #e4e8ed;
`;

const PartnerIntro = styled.div`
  margin-bottom: 24px;
  max-width: 800px;
  color: #687581;
  font-size: 14px;
  line-height: 1.8;
  p { margin: 0; }
  .external-note { margin-top: 8px; font-size: 12px; }
`;

export function CursosGratuitos() {
  const { setTitle } = useTitleAndUser() as { setTitle: (title: string) => void };
  const { isMobile = false } = useNewTheme() as { isMobile?: boolean };

  useEffect(() => {
    setTitle('Cursos gratuitos');
  }, [setTitle]);

  return (
    <Content $isMobile={isMobile}>
      <TutoriaisContainer>
        <PageIntro>
          <span className="eyebrow">Cursos iBox6 · Gratuitos</span>
          <h1>Conhecimento para investir melhor</h1>
          <p>Aproveite nossos conteúdos exclusivos e gratuitos para aprender sobre investimentos, organizar suas finanças e desenvolver estratégias inteligentes para conquistar seus objetivos financeiros.</p>
        </PageIntro>
        <CourseBanner src={image1} alt="Cursos gratuitos — parceria com Mundo GIF" />
        <TutorialPlayer>
          <iframe
            title="Conheça os cursos gratuitos"
            src="https://player-vz-447732c4-8c0.tv.pandavideo.com.br/embed/?v=0f1b5325-2e31-4d16-981c-47af8fb59c1f"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          <div className="player-caption">
            <span className="playing-label">Comece por aqui</span>
            <h2>Conheça os cursos gratuitos</h2>
          </div>
        </TutorialPlayer>
        <LibraryHeading>
          <div>
            <h2>Explore os cursos gratuitos</h2>
            <p>Educação financeira · Parceria com Mundo GIF</p>
          </div>
        </LibraryHeading>
        <PartnerIntro>
          <p>Uma curadoria especial da Mundo GIF para te ajudar a entender melhor seu dinheiro, organizar sua vida financeira e tomar decisões mais conscientes nos seus investimentos.</p>
          <p className="external-note">Os cursos abrem na plataforma Mundo GIF, em uma nova aba.</p>
        </PartnerIntro>
        <CarouselTutoriais />
      </TutoriaisContainer>
    </Content>
  );
}
